import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ScreenOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 16.5H8.5575L22.5 2.5575L21.4425 1.5L19.9425 3H3C2.17157 3 1.5 3.67157 1.5 4.5V16.5H3V4.5H18.4425L1.5 21.4425L2.5575 22.5L7.0575 18H9V21H6V22.5H18V21H15V18H21C21.8284 18 22.5 17.3284 22.5 16.5V6.75H21V16.5ZM13.5 21H10.5V18H13.5V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ScreenOff.vue"]]);
